import React, { useEffect, useState } from "react";
import { Alert, Spinner, Table } from "reactstrap";

import { apiFetch, API } from "../../services/api";
import { readError } from "../../helpers/whatsappTemplates";
import { statsView } from "../../helpers/displaySpaces";

// Chiffres d'une réservation — les mêmes que ceux du partenaire dans son espace : en direct pendant la diffusion,
// puis le bilan de fin de diffusion (GET /display-booking-stats).
const LABELS = {
    st_impressions: "Affichages", st_viewers: "Visiteurs", st_clicks: "Clics", st_ctr: "Taux de clic",
    st_sent: "Envois", st_devices: "Appareils", st_opens: "Ouvertures", st_openRate: "Taux d'ouverture",
};

export function StatsPanel({ booking }) {
    const [st, setSt] = useState(null);
    const [error, setError] = useState(null);
    useEffect(() => {
        (async () => {
            const res = await apiFetch(API.back + `/display-booking-stats?id=${encodeURIComponent(booking.id)}`, { market: false });
            if (!res.ok) { setError(await readError(res)); return; }
            setSt(await res.json());
        })();
    }, [booking.id]);
    if (error) return <Alert color="danger">{error}</Alert>;
    if (!st) return <Spinner size="sm" />;
    const v = statsView(st);
    const head = st.status === "live" ? `En direct, du ${st.from} au ${st.to} (mis à jour chaque jour)`
        : st.status === "final" ? `Bilan de fin de diffusion${st.report?.sentAt ? " (envoyé au partenaire)" : " (envoi en attente)"}`
            : st.status === "upcoming" ? "La diffusion n'a pas encore commencé." : "Format diffusé à la main : pas de mesure automatique.";
    return (
        <div>
            <p className="text-muted">{head}</p>
            {v.totals && (
                <>
                    <div className="d-flex flex-wrap mb-3">
                        {v.keys.map((k, i) => (
                            <div key={k} className="border rounded p-3 mr-2 mb-2" style={{ minWidth: 140 }}>
                                <div className="small text-muted">{LABELS[k]}</div><div className="h4 mb-0">{v.totals[i]}</div>
                            </div>
                        ))}
                    </div>
                    {v.weeks.length > 0 && (
                        <Table size="sm" responsive>
                            <thead><tr><th>Semaine</th>{v.keys.map((k) => <th key={k}>{LABELS[k]}</th>)}</tr></thead>
                            <tbody>{v.weeks.map((w) => <tr key={w.week}><td>{w.week}</td>{w.cells.map((c, i) => <td key={i}>{c}</td>)}</tr>)}</tbody>
                        </Table>
                    )}
                    <p className="small text-muted">{v.push
                        ? "Envois réussis ; ouvertures comptées sur le site et l'application web (les applications iOS et Android ne remontent pas l'ouverture)."
                        : "Affichages à au moins 50 % visibles, visiteurs distincts par semaine, robots exclus."}</p>
                </>
            )}
        </div>
    );
}
